import axios from 'axios';
import {
  getAccessToken,
  refreshDashboardSession,
  SessionExpiredError,
} from './dashboardSession';

export const setupInterceptorsTo = axiosInstance => {
  axiosInstance.interceptors.request.use(config => {
    config.headers = config.headers || {};
    const accessToken = getAccessToken();
    if (config.expectedDashboardAccessToken && config.expectedDashboardAccessToken !== accessToken) {
      throw new SessionExpiredError();
    }
    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
  });
  axiosInstance.interceptors.response.use(
    response => response,
    async error => {
      const config = error.config;
      if (error.response?.status !== 401 || !config) throw error;
      if (config.dashboardSessionRetried) throw new SessionExpiredError();

      // Only retry an explicit authentication rejection, once. Never retry a
      // processor decline, timeout, transport error, or ambiguous payment write.
      config.dashboardSessionRetried = true;
      const rejectedToken = (config.headers?.Authorization || '').replace(/^Bearer /, '');
      config.expectedDashboardAccessToken = await refreshDashboardSession(rejectedToken);
      return axiosInstance(config);
    }
  );
  return axiosInstance;
};

export const tokenizedAxios = setupInterceptorsTo(axios.create());
